import React from "react";
import Context from "../../../../../context";
import {
  CustomModal,
  CustomView,
  UserInformation,
} from "../../../../../components";
import { useTranslation } from "react-i18next";

const CompanyInformation = () => {
  const { showModal, setShowModal, selectedUser } = React.useContext(
    Context.ServiceScreen
  );

  const { t } = useTranslation();

  return (
    <section id="service-screen-show-user-information">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        minWidth={"50vw"}
        maxWidth={"70vw"}
        open={showModal === "SHOW_COMPANY_INFORMATION"}
        overlayClose
      >
        <CustomView.Container className="scroll-content">
          <UserInformation
            avatar={selectedUser?.avatar}
            name={
              selectedUser?.firstName
                ? selectedUser?.firstName
                : selectedUser?.name
            }
            lastName={selectedUser?.lastName ? selectedUser?.lastName : ""}
            phoneNumber={
              selectedUser?.phoneNumber
                ? selectedUser?.phoneNumber
                : selectedUser?.telephone
            }
            isBlock={null}
          />
          <hr />
          <CustomView.Row className="form-column-row">
            {selectedUser?.companyInformation?.address && (
              <CustomView.Column
                medium={5}
                small={12}
                large={4}
                className="form-values form-column"
              >
                <label className="form-label">{t("address")} :</label>
                <p>{selectedUser?.companyInformation?.address}</p>
              </CustomView.Column>
            )}
            {selectedUser?.companyInformation?.city?.TownName && (
              <CustomView.Column
                medium={5}
                small={12}
                large={4}
                className="form-values form-column"
              >
                <label className="form-label">{t("city")} :</label>
                <p>{selectedUser?.companyInformation?.city?.TownName}</p>
              </CustomView.Column>
            )}
            {selectedUser?.companyInformation?.city?.ProvinceName && (
              <CustomView.Column
                medium={5}
                small={12}
                large={4}
                className="form-values form-column"
              >
                <label className="form-label">{t("province")} :</label>
                <p>{selectedUser?.companyInformation?.city?.ProvinceName}</p>
              </CustomView.Column>
            )}
            {selectedUser?.superAgentSchoolInformation?.superAgentName && (
              <CustomView.Column
                medium={5}
                small={12}
                large={4}
                className="form-values form-column"
              >
                <label className="form-label">{t("superAgent")} :</label>
                <p>
                  {selectedUser?.superAgentSchoolInformation?.superAgentName}
                </p>
              </CustomView.Column>
            )}
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default CompanyInformation;
